import { EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';
import { AuthService } from './auth.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./auth.service";
var TagsService = /** @class */ (function () {
    function TagsService(http, authService) {
        this.http = http;
        this.authService = authService;
        this.onEditEvent = new EventEmitter();
    }
    TagsService.prototype.getTagsList = function (params) {
        return this.http.get(environment.apiUrl + "/" + this.authService.getUserType() + "/tags", { params: params })
            .pipe(map(function (res) { return res; }));
    };
    TagsService.prototype.getTag = function (tagTypeUuid) {
        return this.http.get(environment.apiUrl + "/" + this.authService.getUserType() + "/tags/" + tagTypeUuid).pipe(map(function (res) { return res.tag; }));
    };
    TagsService.prototype.createTag = function (tag) {
        return this.http.post(environment.apiUrl + "/" + this.authService.getUserType() + "/tags", tag).pipe(map(function (res) { return res.tag; }));
    };
    TagsService.prototype.updateTag = function (tagId, tag) {
        return this.http.put(environment.apiUrl + "/" + this.authService.getUserType() + "/tags/" + tagId, tag);
    };
    TagsService.prototype.deleteTag = function (tagId) {
        return this.http.delete(environment.apiUrl + "/" + this.authService.getUserType() + "/tags/" + tagId);
    };
    TagsService.ngInjectableDef = i0.defineInjectable({ factory: function TagsService_Factory() { return new TagsService(i0.inject(i1.HttpClient), i0.inject(i2.AuthService)); }, token: TagsService, providedIn: "root" });
    return TagsService;
}());
export { TagsService };
